module.exports = __webpack_public_path__ + "img/benefit-card-dashboard.31d099c2.svg";